// Generated by scripts/build-ui-icons.mjs.
export { EnvelopeSimple as default } from "../ui/glyphs-3";
